import { useNavigate } from "react-router-dom";
import { Button, Card, Divider, Flex, Form, Image, Input, Space, theme } from "antd";

function ThankYou() {
    const { token } = theme.useToken();
    const navigate = useNavigate();

    return (
        <Card style={{ width: "500px", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
            <Flex vertical gap={14}>
                <Space direction="vertical" align="center">
                    <img width={200} style={{ borderRadius: "8px" }} src="https://down-bs-vn.img.susercontent.com/vn-11134233-7ras8-m5xh3hvm3kc8b5_tn.webp" />
                    <span style={{ fontSize: token.fontSizeHeading3, fontWeight: "500" }}>Thank you for registering an account</span>
                    <Flex align="center" justify="center">
                        <Space direction="vertical">
                            <span>Please log in to use the application</span>
                            <Flex align="center" justify="center">

                                <Button type="primary" onClick={() => navigate("/login")}>
                                    Login
                                </Button>
                            </Flex>

                        </Space>

                    </Flex>
                </Space>
            </Flex>
        </Card>
    );
}

export default ThankYou;
